<script setup>
import { ref, computed, inject } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'

const route = useRoute()
const router = useRouter()
const store = useStore()

const detailData = inject('detailData', null)
const redesign = inject('algorithmDetailRedesign', false)
const algorithmList = computed(() => store.getters.algorithmList)

const curData = computed(() => {
  // 优先从 detailData 获取算法类型信息
  const type = detailData.value?.algorithm_type?.type
  if (type) {
    return store.getters.algorithmTypeList[type]
  }
  return null
})

const algorithmCategory = computed(() =>
  algorithmList.value.find((i) => i.type === curData.value?.category)
)

const list = computed(() => redesign ? [{ name: '算法超市', path: 'algostore' }] : [
  {
    name: '首页',
    path: 'home',
  },
  // {
  //   name: '产品与服务',
  //   path: '/',
  // },
  {
    name: 'AlgoStore算法超市',
    path: 'algostore',
  },
])

const handleCategoryRoute = () => {
  router.push({
    path: '/algostore',
    query: {
      category: curData.value?.category,
    },
  })
}

const goToRoute = (routename) => {
  router.push(`/${routename}`)
}
</script>

<template>
  <div class="breadcrumb">
    <a-breadcrumb>
      <a-breadcrumb-item v-for="item in list" :key="item.path"
        ><span class="item" @click="goToRoute(item.path)">{{
          item.name
        }}</span></a-breadcrumb-item
      >
      <a-breadcrumb-item v-if="algorithmCategory?.name">
        <span class="item" @click="handleCategoryRoute">{{
          algorithmCategory?.name
        }}</span>
      </a-breadcrumb-item>
      <a-breadcrumb-item
        ><span>{{ detailData?.name || curData?.name }}</span></a-breadcrumb-item
      >
    </a-breadcrumb>
  </div>
</template>

<style scoped lang="scss">
.breadcrumb {
  margin-top: 20px;
  margin-left: 160px;
}

.item {
  cursor: pointer;
  font-size: 15px;
}

:deep() {
  .ant-breadcrumb a {
    color: #333;
    font-size: 16px;
  }

  .ant-breadcrumb li:last-child {
    font-weight: 600;
  }
}
</style>
